import clsx from "clsx";
import React, { ReactNode, useContext } from "react";

import { CommonColors } from "../../../../types/colors";
import { TabsContext } from "../../tabs-context";
import { colorScheme } from "./styles";

export interface PillTabHeaderItemProps {
  id: string;
  className?: string;
  header: ReactNode;
  subHeader?: ReactNode;
  color?: CommonColors;
}

export function PillTabHeaderItem({
  id,
  className,
  header,
  subHeader,
  color = CommonColors.Light,
}: PillTabHeaderItemProps) {
  const { activeTab, setActiveTab } = useContext(TabsContext);
  const isActive = activeTab === id;
  const { activeItemClasses } = colorScheme[color];
  return (
    <div
      onClick={() => setActiveTab(id)}
      className={clsx(
        "border rounded-full text-lg py-2 px-5 whitespace-nowrap cursor-pointer",
        "transition-colors ease-in duration-300 select-none",
        isActive ? activeItemClasses : "bg-transparent border-transparent",
        className
      )}
    >
      <h3 className="font-medium text-xl">{header}</h3>
      {subHeader && <p className="font-light text-sm">{subHeader}</p>}
    </div>
  );
}
